import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"

export default class extends Controller {
  static values = { 
    autoplay: { type: Boolean, default: true },
    delay: { type: Number, default: 5000 }
  }

  connect() {
    if (this.element.swiper) {
      this.element.swiper.destroy(true, true)
    }
    
    this.element.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden')
    
    setTimeout(() => {
      this.initSwiper()
    }, 100)
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  initSwiper() {
    const nextButton = this.element.querySelector('.swiper-button-next')
    const prevButton = this.element.querySelector('.swiper-button-prev')
    const slides = this.element.querySelectorAll('.swiper-slide')
    
    // Limpiar clases de inicialización previa
    this.element.classList.remove(
      'swiper-initialized', 
      'swiper-horizontal', 
      'swiper-backface-hidden',
      'swiper-3d',
      'swiper-css-mode'
    )
    
    this.swiper = new Swiper(this.element, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: slides.length > 3,
      autoplay: this.autoplayValue ? {
        delay: this.delayValue,
        disableOnInteraction: false,
      } : false,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    })
    
    // Event listeners manuales como respaldo
    if (nextButton && prevButton) {
      nextButton.addEventListener('click', () => {
        if (this.swiper) {
          this.swiper.slideNext()
        }
      })
      
      prevButton.addEventListener('click', () => {
        if (this.swiper) {
          this.swiper.slidePrev()
        }
      })
    }
  }
}